import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {DataKey, WorkflowId} from "common/flowmaster/types/workflow";
import {Test} from "common/flowmaster/types/test";

export type WorkflowTestAddAction = {
  type: WorkflowsActionTypes["WORKFLOW_TEST_ADD"]["SUCCESS"];
  payload: {links: Record<string, unknown>; tests: Test[]};
};

export default function addWorkflowTest(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_TEST_ADD,
    (
      organisationId: OrganisationId,
      workflowContextId: WorkflowId,
      links: Record<string, unknown>,
      dataKey: DataKey,
      key: string,
      nameKey?: string,
    ) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/workflow_context/${workflowContextId}/test`,
          {links, data_key: dataKey, key, name_key: nameKey},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
